
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vitiligoBasicInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visit_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onset_age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symmetry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vitiligo_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current_location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mucosal_involvement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leukotrichia"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bsa_score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"progression_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remark1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remark2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remark3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lesion_color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distribution_pattern"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stability_features"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boundary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symptoms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wood_lamp_color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wood_lamp_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onset_season"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onset_trigger"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aggravation_trigger"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recurrence_trigger"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comorbidities"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"family_history"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"family_history_notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoimmune_family_history"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoimmune_family_notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"covid_vaccination"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"covid_infection"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"treatment_history"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"systemic_medication"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topical_medication"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phototherapy_method"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phototherapy_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surgical_treatment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"other_treatments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"create_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"update_time"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":973}};
    doc.loc.source = {"body":"query($id:Int!) {\n   vitiligoBasicInfo(id: $id){\n      id\n      visit_date\n      height\n      weight\n      onset_age\n      duration_months\n      symmetry\n      vitiligo_type\n      first_location\n      current_location\n      mucosal_involvement\n      leukotrichia\n      bsa_score \n      progression_status\n      remark1\n      remark2\n      remark3\n      lesion_color\n      distribution_pattern\n      stability_features\n      boundary\n      symptoms\n      wood_lamp_color\n      wood_lamp_area\n      onset_season\n      onset_trigger\n      aggravation_trigger\n      recurrence_trigger\n      comorbidities\n      family_history\n      family_history_notes\n      autoimmune_family_history\n      autoimmune_family_notes\n      covid_vaccination\n      covid_infection\n      treatment_history\n      systemic_medication\n      topical_medication\n      phototherapy_method\n      phototherapy_type\n      surgical_treatment\n      other_treatments\n      create_time\n      update_time\n   }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
